<template>
    <q-input
        ref="myInput"
        v-bind="$attrs"
        :outlined="outlined"
        :stack-label="stackLabel"
        :borderless="borderless"
        :dense="dense"
        :filled="filled"
        :value="value"
        :rules="rules"
        :flat="flat"
        :bottom-slots="false"
        emit-value
        @keydown="emitSubmitOnEnter($event);"
        @input="$emit('input', $event)"
        @click="getCursorPosition()"
        :data-component-name="$options.name"
    >
        <template v-slot:after v-if="afterIcon || withEmoji">
            <q-btn round dense flat :icon="afterIcon" :color="afterIconColor" @click="$emit('afterIcon-click')" v-if="afterIcon" />
            <StEmojiPicker
                v-if="withEmoji"
                @input="setEmoji($event)"
                class=""
                ref="EmojiPicker"
                @click.stop
            />
        </template>
        <template v-slot:append v-if="iconButton">
            <q-icon :name="iconButton"
                style="cursor: pointer"
                @click="$emit('iconButton-click')"
            />
        </template>
        <template v-slot:prepend v-if="iconButtonPrefix">
            <q-icon :name="iconButtonPrefix"
            />
        </template>
    </q-input>
</template>
<script>
    import QInput from 'quasar'
    import { emojiReplacementList } from '@/js/utilities'
    export default {
        name: 'Input',
        extends: QInput,
        props: {
            outlined: {
                type: Boolean,
                default: false
            },
            borderless: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            flat: {
                type: Boolean,
                default: false
            },
            stackLabel : {
                type: Boolean,
                default: false
            },
            rules: {
                type: Array,
                default(){ return new Array()}
            },
            value: [String, Number],
            iconButton: {
                type: String,
                default: null
            },
            iconButtonPrefix: {
                type: String,
                default: null
            },
            afterIcon: {
                type: String,
                default: null
            },
            afterIconColor: {
                type: String,
                default: 'grey'
            },
            submitOnEnter: {
                type: Boolean,
                default: false
            },
            withEmoji: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                cursorPosition: 0,
                withEmojiTO: {},
                emojiShortcuts: emojiReplacementList()
            }
        },
        mounted(){
            if(this.$attrs.required===true || this.$attrs.required==="true"){
                this.rules.push(val => !!val)
            }

            this.$nextTick(() => {
                this.$eventBus.$on('reset-validation', ()=> {
                    if (this.$refs.myInput) this.$refs.myInput.resetValidation()
                })
            })
        },
        methods: {
            resolveEmoji(toDelay=250){
                if(!this.withEmoji || !this.emojiShortcuts || this.emojiShortcuts.length==0) return;

                clearTimeout(this.withEmojiTO);
                this.withEmojiTO=setTimeout(function(){
                    let value=this.value;
                    this.emojiShortcuts.forEach(function(item){
                        value=value.replaceAll(item.src, String.fromCodePoint(item.dst));
                    })
                    this.$emit('input', value)
                }.bind(this), toDelay)
            },
            setEmoji(event){
                this.getCursorPosition();

                let value=this.value;
                let textBefore = value.substring(0,  this.cursorPosition);
                let textAfter  = value.substring(this.cursorPosition, value.length);
                
                // this.cursorPosition++;
                this.$refs.myInput.focus();
                this.$emit('input', textBefore+event+textAfter)
            },
            getCursorPosition(){
                if(this.$refs["myInput"]?.$el?.control?.selectionStart){
                    this.cursorPosition=this.$refs["myInput"].$el.control.selectionStart
                }
            },
            emitSubmitOnEnter(event){
                this.getCursorPosition();
                this.resolveEmoji();

                if(!this.submitOnEnter) return;

                if(event.key=="Enter" && !event.shiftKey){
                    event.preventDefault();
                    this.$nextTick(function(){
                        this.$emit('enter-submit');
                    }.bind(this))
                }
            }
        }
    }
</script>

<style scoped>
    .q-field--with-bottom {
        padding-bottom: 0;
    }
</style>